import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import * as accountTypes from '@account/store/types';
import * as urlHelper from '@appbase/util/url-helper'
import docViewerHelper, * as docviewerHelper from '@appbase/util/doc-viewer-helper'
import api from '@appbase/api/usercard'

import Barcode from './Barcode.vue';

@Component({
    components: {
        Barcode
    },
    computed: {
        ...mapGetters({
            currentUser: accountTypes.USER,
            userCurrent: accountTypes.CURRENT,
        }),
    },
})
export default class EmployeeCard extends Vue {
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    get closeImage() {
        return require(`@appbase/assets/out/card_close.png`);
    }

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    currentUser!: account.User;
	userCurrent!:account.TCurrent

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    targetPosition: DOMRect = Object.create(null);
    photoUrl: string = '';
    currentTab: string = 'discount';

    isLoading: boolean = true;
    isPhotoLoading: boolean = true;
    isFocusing: boolean = false;

    styleTop: string = '0';
    styleLeft: string = '0';

    ghostImage: any = require('@appbase/assets/ghost.png');
    ghostLoading: any = require('@appbase/assets/ghost_loading.png');

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    getPhotoPath() {
        if(this.currentUser == null)
            return;

        this.isPhotoLoading = true;
        if (this.currentUser.personId) {
            this.photoUrl = `https://ehr.kyobobook.co.kr/EmpPhotoOut.do?enterCd=KBB&sabun=${this.currentUser.personId}`;
        } else {
            this.photoUrl = '/cm/gres/faux/images/ghost.png';
        }
        this.isPhotoLoading = false;
    }

    setLocation() {          
        var targetElem = document.getElementById('employee-card-button');

        if (targetElem == null) return;

        let elRect = targetElem.getBoundingClientRect();        

        let posTop = elRect.y + elRect.height;
        let posLeft = elRect.x;   
        
        this.styleTop = `${posTop}px`;
        this.styleLeft = `${posLeft}px`;                     
    }

    onClickClose() {
        this.$emit('close');   
    }

    tabChanged(tabName: string) {
        this.currentTab = tabName;
    }

    downloadCard(cardType: string) {      
        let cardHTML = (this.$refs.refCard as HTMLDivElement).outerHTML;
        api.saveCardContent(cardHTML, this.currentTab).then(res => {
            let pdfURl = docViewerHelper.convertPdf(res, 340, 485)
            window.open(pdfURl);
        });
    }

    async openPurchaseList(){
        var url = ''
        if(this.isTeams){
            var params = `personCode=${this.currentUser.personCode}&timeStamp=${new Date().getTime()}`
            url = await urlHelper.redirectWithProcessToken(`/home/purchase`,params,this.currentUser.comCode, this.userCurrent.key)
        }
        else{
            url = `${window.location.origin}${process.env.NODE_ENV === 'production'?'/po':''}/home/purchase`
        }
        window.open(url);
    }

    created() {
        this.getPhotoPath();
        this.setLocation();

        window.addEventListener('close-modal', this.onClickClose);
    }

    beforeDestroy() {
        window.removeEventListener('close-modal', this.onClickClose);
    }
}
